import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
export function FilterChip(t0) {
  const $ = _c(7);
  const {
    active,
    onToggle,
    children
  } = t0;
  let t1;
  if ($[0] !== active || $[1] !== onToggle) {
    t1 = () => onToggle(!active);
    $[0] = active;
    $[1] = onToggle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== active || $[4] !== children || $[5] !== t1) {
    t2 = <button type="button" data-active={active} onClick={t1} className="ui-filter-chip">{children}</button>;
    $[3] = active;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}